var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "inner",
    { on: { apply: _vm.applySort, clear: _vm.clear } },
    _vm._l(_vm.options, function(option) {
      return _c("mobile-multiselect-item", {
        key: option.value,
        attrs: {
          title: option.name,
          "is-selected": _vm.isSelected(option.value)
        },
        nativeOn: {
          click: function($event) {
            return _vm.select(option.value)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }